<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Save"
		v-on:closeModal="cancelUpload"
		v-on:confirm="saveFileDetails">

		<slot></slot>

		<template v-if="visible">

			<form-group label="File" col-class="col-md-4">
				<upload-field-with-panel
					api-model="LibraryUpload"
					upload-type="file"
					v-model="fileObj"
					v-on:uploaded="fileUploaded">
				</upload-field-with-panel>
			</form-group>

			<field label="Add a Caption"
				col-class="col-md-4"
				v-model="caption">
			</field>

			<field label="Tag it"
				col-class="col-md-4"
				v-model="tags"
				:params="{type:'select-multi',options:tagsOptions}">
			</field>

			<field label="Link Sharing"
				col-class="col-md-4"
				v-model="sharing_on"
				:params="{type:'boolean'}">
			</field>

			<div v-if="sharing_on == 1 && record" class="d-flex flex-row">
				<template v-if="shareLink">
					<div style="flex-grow: 1">
						<field
							label="Share Link"
							col-class="stacked"
							:value="shareLink">
						</field>
					</div>
					<div style="align-self: flex-end;margin-bottom: 0.3rem">
						<button class="btn btn-light" type="button" title="Copy link to clipboard" v-on:click="copyToClipboard(shareLink)">
							<i class="fa fa-copy"></i>
						</button>
					</div>
				</template>
				<p v-else>The share link will be generated after saving</p>
			</div>
		</template>

	</modal-dialog>
</template>
<script type="text/javascript">
import FormGroup from "@/components/FormGroup"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

export default {
	name: "JobFileUploadModal",
	components: {
		FormGroup,
		UploadFieldWithPanel,
		Field,
		ModalDialog
	},
	props: ["title","visible","storeLocation","storeLocationMap","record","isEdit","jobId","isFile"], // isFile requires 'is_file' key exists for resource
	data() {
		return {
			shareLink: "",
			sharing_on: "",
			caption: "",
			fileObj: {},
			file_id: null,
			filename: "",
			tags: []
		}
	},
	watch: {
		visible() {
			let vm = this

			this.resetModal()

			if (this.visible && this.$store.fileTags.length == 0)
				this.fetchFileTags()

			if (this.visible && this.isEdit && this.record) {
				let fields = ["caption","file_id","filename"]

				fields.forEach(field => {
					vm[field] = vm.record[field]
				})

				this.sharing_on = this.record.UploadFile.sharing_on
				this.fileObj = this.record.UploadFile
				this.tags = this.record.FileTag.map(tag => tag.id)
				this.shareLink = window.apiRoot+"portal/sharing/"+this.record.UploadFile.slug
			}
		}
	},
	computed: {
		tagsOptions() {
			return this.optionify(this.$store.fileTags,"name")
		}
	},
	methods: {
		resetModal() {
			this.shareLink = ""
			this.sharing_on = ""
			this.caption = ""
			this.fileObj = {}
			this.file_id = null
			this.filename = ""
			this.tags = []
		},
		cancelUpload() {
			this.$emit("closeModal")

			if (this.file_id && !this.isEdit) {
				//we have to delete the file quietly in the background so we don't clutter anything
				this.postData("LibraryUpload/delete",{id: this.file_id})
			}
		},
		saveFileDetails() {
			let vm = this

			let payload = {}

			let fields = ["notes","caption"]
			fields.forEach(field => {
				payload[field] = vm[field]
			})

			if (this.storeLocation == 'project')
				payload.job_id = this.jobId
			else
				payload[this.storeLocationMap[this.storeLocation].jobField] = this.jobId

			payload.file_id = this.file_id

			payload.FileTag = this.tags

			let model = this.storeLocationMap[this.storeLocation].apiResource

			let message = "File uploaded into Files tab"
			let skipSave = false
			if (this.isEdit) {
				payload.id = this.record.id
				message = "File details updated"
			}
			else if (!payload.file_id) {
				skipSave = true
				this.alertFail("You need to upload a file!")
			} else if (this.isFile) {
				payload.is_file = 1
			}

			let filePayload = {
				id: this.file_id,
				sharing_on: this.sharing_on
			}

			if (!skipSave) {
				let promises = [
					this.postData(model+"/save",payload,true),
					this.postData("UploadFile/update",filePayload)
				]

				Promise.all(promises).then(responses => {
					if (responses[0].success) {
						vm.alertSaved(message)
						vm.$emit("modelChanged",{file_id: this.file_id})
						vm.$emit("closeModal")
					}
				})
			}
		},
		fileUploaded(response) {
			if (this.isEdit) {
				//delete the old file
				if (this.file_id)
					this.postData("LibraryUpload/delete",{id: this.file_id})
			}


			this.file_id = response.data.id
			this.filename = response.data.original_filename

			this.$emit("fileUploaded",{file_id: this.file_id, filename: this.filename})
		},
		fetchFileTags() {

			let vm = this

			let field = this.storeLocationMap[this.storeLocation].tagFilterField

			let params = {
				filters: [
					[field,1]
				]
			}

			this.getJSON("FileTag/get",params).then(response => {
				if (response.success)
					vm.$store.fileTags = response.data
			})
		}
	}
}	
</script>